module.exports = __webpack_public_path__ + "miscusi-static/fonts/icomoon.60bb1e44510fa2525b67bd0786478a28.ttf";